import React from 'react';
import * as s from './styled-tip-password';
import { icons } from '../../assets/index';

const TipPassword = () => {
  return (
    <s.Box>
      <img src={icons.TipIcon} alt="" />
      <s.Title>A senha deve conter:</s.Title>
      <s.Description>- De 8 a 10 dígitos</s.Description>
      <s.Description>- No mínimo 1 letra maiúscula</s.Description>
      <s.Description>- No mínimo 1 letra minúscula</s.Description>
      <s.Description>- No mínimo 1 caractere especial</s.Description>
    </s.Box>
  );
};

export default TipPassword;
